module.exports = "mutation Login($email: String!, $password: String!) {\n  beginSession(email: $email, password: $password) {\n    sessionToken\n  }\n}\n"